// header element
const header = document.querySelector('#header');
const announcementBarBottom = document.querySelector('#announcement');

// listen to scrolling
window.addEventListener('scroll', handleHeader);

// header gets color as you scroll
function handleHeader() {
    const announcementPosition = announcementBarBottom.getBoundingClientRect().bottom;
    if (announcementPosition <= 0) {
        header.style.top = '0';
        header.classList.add('active');
    } else {
        header.style.top = `${announcementPosition}px`;
        header.classList.remove('active');
    }
}

// run on start
handleHeader();

/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelector("#headerMenu").addEventListener("click", openNav);


// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});